import { NavigateOptions } from "react-router-dom";
import { router } from "../routes";

export function classNames(...classes: (string | boolean)[]) {
  return classes.filter(Boolean).join(" ");
}

const { REACT_APP_S3PUBLIC_URL: S3PUBLIC_URL } = process.env;

export function navigateTo(props: string = "", options: NavigateOptions = {}) {
  return router.navigate(props?.[0] === "/" ? props : `/${props}`, options);
}

export const getPreSignedUrl = ({ claimId, fileName, prefix = "" }) => {
  return `${S3PUBLIC_URL}${prefix}/claims_documentation/CL-${claimId}/photos-consumer/${fileName}`;
};
export function checkAllKeysHaveValue(obj, excludeValues = []) {
  if (Array.isArray(obj)) {
    return (
      obj.length > 0 &&
      obj.every((item) => checkAllKeysHaveValue(item, excludeValues))
    );
  } else if (typeof obj === "object" && obj !== null) {
    return Object.values(obj).every((value) =>
      checkAllKeysHaveValue(value, excludeValues)
    );
  } else {
    obj ??= "";
    return obj.toString().length > 0;
  }
}

export const formatCurrency = (value: number | string) => {
  const num =
    typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
  if (isNaN(num)) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(num);
};

export const getSafeArray = (value) => {
  if (Array.isArray(value)) {
    return value;
  }
  if (value) {
    return [value];
  }
  return [];
};
